/**
 * Volta pós-login: quem abre uma tela privada sem sessão vai pro `/login?voltar=<tela>` e, entrando, volta pra ela.
 * O `voltar` chega pela URL — é de quem montou o link, não do app —, então só caminho INTERNO passa.
 * Permission da tela não é decidida aqui: o destino aplica o próprio guard. Ver `voltaAposLogin.md`.
 */

export const PARAM_VOLTAR = 'voltar'

const DESTINO_PADRAO = '/chatbot'
/** Origem fictícia só pra resolver o caminho e conferir que ele não sai do app. */
const BASE = 'http://interno.invalid'

export function loginComVolta(local: Pick<Location, 'pathname' | 'search' | 'hash'>): string {
  if (local.pathname === '/' || local.pathname === DESTINO_PADRAO) return '/login'
  const caminho = `${local.pathname}${local.search}${local.hash}`
  return `/login?${PARAM_VOLTAR}=${encodeURIComponent(caminho)}`
}

export function destinoAposLogin(search: string): string {
  const voltar = new URLSearchParams(search).get(PARAM_VOLTAR)
  if (!voltar || !voltar.startsWith('/') || voltar.startsWith('//') || voltar.startsWith('/\\')) return DESTINO_PADRAO
  let url: URL
  try {
    url = new URL(voltar, BASE)
  } catch {
    return DESTINO_PADRAO
  }
  if (url.origin !== BASE || url.pathname === '/login' || url.pathname.startsWith('/login/')) return DESTINO_PADRAO
  return `${url.pathname}${url.search}${url.hash}`
}
